// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../components/navigation/AuthenticationStateManager";
// import "./ResumeResults.css";

// export default function ResumeResults() {
//   const navigate = useNavigate();
//   const { isAuthenticated } = useAuth();

//   const copyToClipboard = (text) => {
//     navigator.clipboard.writeText(text);
//     alert("Copied!");
//   };


//   return (
//     <div className="min-h-screen bg-background">
//       <NavigationTabBar isAuthenticated={isAuthenticated} />

//     <main className="pt-20">
//   <div className="rr-container wide">

//     {/* HERO SCORE */}
//     <section className="rr-hero improved">
//       <div className="rr-score-block">
//         <div className="rr-score-circle">
//           <span>62</span>
//           <small>/ 100</small>
//         </div>
//         <div className="rr-score-meta">
//     <h1>Your Resume Is Not Interview-Ready Yet</h1>
// <p className="rr-subtitle">
//   You pass ATS screening, but recruiters may skip your resume without improvements.
// </p>
         
//         </div>
//       </div>

//       <div className="rr-signal-inline">
//         <Signal label="ATS Parsing" value="PASS" type="green" />
//         <Signal label="Job Match" value="MEDIUM" type="yellow" />
//         <Signal label="Recruiter Impact" value="LOW" type="red" />
//       </div>
//     </section>

//     {/* FIX FIRST */}
//     <section className="rr-card rr-priority improved">
//       <h2>🚨 Top Fixes (Do These First)</h2>

//       <div className="rr-fix-grid">
//         <FixItem
//           title="Missing Airflow & Snowflake keywords"
//           impact="HIGH"
//           action="Add Keywords"
//         />
//         <FixItem
//           title="Experience bullets lack measurable impact"
//           impact="MEDIUM"
//           action="Rewrite Bullets"
//         />
//         <FixItem
//           title="Resume layout may confuse ATS"
//           impact="LOW"
//           action="View Layout Tips"
//         />
//       </div>
//     </section>

//     {/* IMPROVEMENTS */}
    
//     <section className="rr-card improved">
//       <h2>✨ Instant Resume Improvements</h2>
// <div className="rr-improve-section">
//       <ImproveBox
//         before="Worked on data pipelines"
//         after="Built scalable ETL pipelines using Airflow & Python, processing 10M+ records daily"
//         copy={copyToClipboard}
//       />
// </div>

// <div className="rr-improve-section">
//       <ImproveBox
//         before="Responsible for ETL jobs"
//         after="Designed and maintained ETL workflows improving efficiency by 30%"
//         copy={copyToClipboard}
//       />
//       </div>
//     </section>

//     {/* CTA */}
//     <section className="rr-cta improved sticky">
//       <div>
//         <h2>Make Your Resume Interview-Ready</h2>
//         <p>
//           Apply fixes and download an ATS-optimized resume recruiters will read.
//         </p>
//       </div>
//       <button onClick={handleCTA}>
//         Apply Fixes & Download Resume 🚀
//       </button>
//       <small>No signup required until download</small>
//     </section>

//   </div>
// </main>


     
//     </div>
//   );

//   function Signal({ label, value, type }) {
//   return (
//     <div className={`rr-signal-pill ${type}`}>
//       <span>{label}</span>
//       <strong>{value}</strong>
//     </div>
//   );
// }

// function FixItem({ title, impact, action }) {
//   return (
//     <div className={`rr-fix-item ${impact.toLowerCase()}`}>
//       <div>
//         <h4>{title}</h4>
//         <span className={`rr-severity ${impact.toLowerCase()}`}>
//           Impact: {impact}
//         </span>
//       </div>
//       <button>{action}</button>
//     </div>
//   );
// }

// function ImproveBox({ before, after, copy }) {
//   return (
//     <div className="rr-improve-box improved">
//       <div className="before">❌ {before}</div>
//       <div className="after">
//         ✅ {after}
//         <button onClick={() => copy(after)}>Copy</button>
//       </div>
//     </div>
//   );
// }

// }


// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../components/navigation/AuthenticationStateManager";
// import { useEffect, useState } from "react";
// import "./ResumeResults.css";
// import NavigationTabBar from "../../components/navigation/NavigationTabBar";

// export default function ResumeResults() {

//   const navigate = useNavigate();
//   const { isAuthenticated } = useAuth();

//   const [data, setData] = useState(null);

//   /* ===============================
//      LOAD DATA FROM LOCAL STORAGE
//   =============================== */

//   useEffect(() => {

//     if (!isAuthenticated) {
//       navigate("/login");
//       return;
//     }

//     const stored = localStorage.getItem("resume_analysis_data");

//     if (stored) {
//       setData(JSON.parse(stored));
//     }

//   }, [isAuthenticated, navigate]);

//   /* ===============================
//      HELPERS
//   =============================== */

//   const copyToClipboard = (text) => {
//     navigator.clipboard.writeText(text);
//     alert("Copied!");
//   };

//   const handleCTA = () => {
//     navigate("/resume-builder");
//   };

//   /* ===============================
//      EMPTY STATE
//   =============================== */

//   if (!data) {
//     return (
//       <div className="text-center mt-20">
//         <h2>No analysis found</h2>
//         <button onClick={() => navigate("/resume-builder")}>
//           Upload Resume
//         </button>
//       </div>
//     );
//   }

//   /* ===============================
//      DYNAMIC VALUES
//   =============================== */

//   const score = data.score || 0;
//   const ats = data.atsParsing || "FAIL";
//   const job = data.jobMatch || "LOW";
//   const impact = data.recruiterImpact || "LOW";

//   const title =
//     score >= 80
//       ? "Your Resume Is Interview-Ready 🚀"
//       : score >= 50
//       ? "Your Resume Needs Improvement"
//       : "Your Resume Is Not Interview-Ready Yet";

//   const subtitle =
//     score >= 80
//       ? "Your resume is strong and ready to apply!"
//       : "Fixing high-impact issues can increase your chances of getting shortlisted.";

//   /* ===============================
//      UI
//   =============================== */

//   return (
//     <div className="min-h-screen bg-background">

//       <NavigationTabBar isAuthenticated={isAuthenticated} />

//       <main className="pt-20">
//         <div className="rr-container wide">

//           {/* HERO */}
//           <section className="rr-hero improved">

//             <div className="rr-score-block">

//               <div className="rr-score-circle">
//                 <span>{score}</span>
//                 <small>/ 100</small>
//               </div>

//               <div className="rr-score-meta">
//                 <h1>{title}</h1>
//                 <p className="rr-subtitle">{subtitle}</p>
//               </div>

//             </div>

//             <div className="rr-signal-inline">
//               <Signal label="ATS Parsing" value={ats} type="green" />
//               <Signal label="Job Match" value={job} type="yellow" />
//               <Signal label="Recruiter Impact" value={impact} type="red" />
//             </div>

//           </section>

//           {/* FIXES */}
//           <section className="rr-card rr-priority improved">
//             <h2>🚨 Top Fixes (Do These First)</h2>

//             <div className="rr-fix-grid">

//               <FixItem
//                 title={job === "LOW" ? "Low keyword match" : "Optimize keywords further"}
//                 impact="HIGH"
//                 action="Add Keywords"
//               />

//               <FixItem
//                 title="Add measurable impact to experience"
//                 impact="MEDIUM"
//                 action="Rewrite Bullets"
//               />

//               <FixItem
//                 title="Improve ATS formatting & structure"
//                 impact="LOW"
//                 action="View Layout Tips"
//               />

//             </div>
//           </section>

//           {/* IMPROVEMENTS */}
//           <section className="rr-card improved">
//             <h2>✨ Instant Resume Improvements</h2>

//             <div className="rr-improve-section">
//               <ImproveBox
//                 before="Worked on data pipelines"
//                 after="Built scalable ETL pipelines using Airflow & Python, processing 10M+ records daily"
//                 copy={copyToClipboard}
//               />
//             </div>

//             <div className="rr-improve-section">
//               <ImproveBox
//                 before="Responsible for ETL jobs"
//                 after="Designed and maintained ETL workflows improving efficiency by 30%"
//                 copy={copyToClipboard}
//               />
//             </div>

//           </section>

//           {/* CTA */}
//           <section className="rr-cta improved sticky">
//             <div>
//               <h2>Make Your Resume Interview-Ready</h2>
//               <p>
//                 Apply fixes and download an ATS-optimized resume recruiters will read.
//               </p>
//             </div>

//             <button onClick={handleCTA}>
//               Apply Fixes & Download Resume 🚀
//             </button>

//             <small>No signup required until download</small>
//           </section>

//         </div>
//       </main>

//     </div>
//   );

//   /* ===============================
//      COMPONENTS
//   =============================== */

//   function Signal({ label, value, type }) {
//     return (
//       <div className={`rr-signal-pill ${type}`}>
//         <span>{label}</span>
//         <strong>{value}</strong>
//       </div>
//     );
//   }

//   function FixItem({ title, impact, action }) {
//     return (
//       <div className={`rr-fix-item ${impact.toLowerCase()}`}>
//         <div>
//           <h4>{title}</h4>
//           <span className={`rr-severity ${impact.toLowerCase()}`}>
//             Impact: {impact}
//           </span>
//         </div>
//         <button>{action}</button>
//       </div>
//     );
//   }

//   function ImproveBox({ before, after, copy }) {
//     return (
//       <div className="rr-improve-box improved">
//         <div className="before">❌ {before}</div>
//         <div className="after">
//           ✅ {after}
//           <button onClick={() => copy(after)}>Copy</button>
//         </div>
//       </div>
//     );
//   }
// }

import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/navigation/AuthenticationStateManager";
import NavigationTabBar from "../../components/navigation/NavigationTabBar";
import "./ResumeResults.css";

export default function ResumeResults() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // ✅ GET DATA FROM LOCALSTORAGE (NO STATIC)
  const savedData = JSON.parse(localStorage.getItem("resume_analysis_data")) || {};

  const score = savedData.improvedScore || savedData.overallScore;
  const atsParsing = savedData.atsParsing || "FAIL";
  const jobMatch = savedData.jobMatch || "LOW";
  const recruiterImpact = savedData.recruiterImpact || "LOW";
  const preview = savedData.preview || { improvements: [] };

  // ✅ DEBUG (remove later)
  console.log("Resume Analysis Data:", savedData);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied!");
  };

  const handleCTA = () => {
    navigate("/download");
  };

  return (
    <div className="min-h-screen bg-background">
      <NavigationTabBar isAuthenticated={isAuthenticated} />

      <main className="pt-20">
        <div className="rr-container wide">

          {/* HERO SCORE */}
          <section className="rr-hero improved">
            <div className="rr-score-block">

              <div className="rr-score-circle">
                <span>{score}</span>
                <small>/ 100</small>
              </div>

              <div className="rr-score-meta">
                <h1>
                  {score >= 80
                    ? "Your Resume Is Interview-Ready 🚀"
                    : score >= 60
                    ? "Your Resume Is Close 👍"
                    : "Your Resume Needs Improvement"}
                </h1>

                <p className="rr-subtitle">
                  {score >= 80
                    ? "You're highly optimized for ATS and recruiters."
                    : score >= 60
                    ? "You're passing ATS but improvements can boost your chances."
                    : "You may pass ATS, but recruiters may skip your resume."}
                </p>
              </div>

            </div>

            <div className="rr-signal-inline">
              <Signal label="ATS Parsing" value={atsParsing} type="green" />
              <Signal label="Job Match" value={jobMatch} type="yellow" />
              <Signal label="Recruiter Impact" value={recruiterImpact} type="red" />
            </div>
          </section>

          {/* IMPROVEMENTS */}
          <section className="rr-card improved">
            <h2>✨ Key Improvements</h2>

            {preview.improvements && preview.improvements.length > 0 ? (
              preview.improvements.map((item, index) => (
                <ImproveBox
                  key={index}
                  before="Needs improvement"
                  after={item}
                  copy={copyToClipboard}
                />
              ))
            ) : (
              <p>No suggestions available</p>
            )}
          </section>

          {/* CTA */}
          <section className="rr-cta improved sticky">
            <div>
              <h2>Make Your Resume Interview-Ready</h2>
              <p>
                Apply fixes and download an ATS-optimized resume recruiters will read.
              </p>
            </div>

            <button onClick={handleCTA}>
              Apply Fixes & Download Resume 🚀
            </button>

            <small>No signup required until download</small>
          </section>

        </div>
      </main>
    </div>
  );
}

/* ---------- COMPONENTS ---------- */

function Signal({ label, value, type }) {
  return (
    <div className={`rr-signal-pill ${type}`}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

function ImproveBox({ before, after, copy }) {
  return (
    <div className="rr-improve-box improved">
      <div className="before">❌ {before}</div>
      <div className="after">
        ✅ {after}
        <button onClick={() => copy(after)}>Copy</button>
      </div>
    </div>
  );
}